import React, {useCallback} from 'react';
import {Select, SelectProps} from "./Select";
import {useEffect, useState} from "react";

type SelectIdProps<Type extends { id: any}> = Omit<SelectProps<Type>,'value'> & {value:string|number|string[]|number[]};



export function SelectId<Type extends { id: any}>(props:SelectIdProps<Type>) {
    // convert values here before passing to the select...
    const [selectedFull,setSelectedFull] = useState<Type|Type[]|null>([]);
    useEffect(()=>{
        let newValue:Type[]|Type|null = props.multiple?[]:null;
        if(props.value||props.value==='0'||props.value===0) {
            if(props.multiple) {
                newValue = [];
                (props.value as Array<number|string>).forEach((valueEntry)=>{
                    if(!valueEntry) {
                        return;
                    }
                    const found = props.options.find((option)=>option.id==valueEntry);
                    if(found) { (newValue as Array<Type>).push(found); }
                });
            } else {
                const found = props.options.find((option)=>option.id==props.value);
                if(found) { newValue = found; }
            }
        }
        setSelectedFull(newValue);
    },[props.options,props.value,props.multiple]);
    const onChange = useCallback((evt) => {
        console.log('CHANGE4',evt)
        let value = null;
        if(props.multiple) {
            value = evt.target.value.map((v)=>v?.id);
        } else {
            value = evt.target.value?.id;
        }
        props.onChange({target:{name:evt.target.name,value:value}});
    },[props.onChange]);
    console.log('SELECTID!!!!',props);
    return <Select<Type> {...props} value={selectedFull} onChange={onChange} />;
}